export default "__VITE_ASSET__C8uIeURv__"